import {
  GET_GOALS_IN_PROGRESS,
  GET_GOALS_SUCCESS,
  GET_GOALS_FAILED,
  UPDATE_GOALS_IN_PROGRESS,
  UPDATE_GOALS_SUCCESS,
  UPDATE_GOALS_FAILED,
  ARCHIVE_GOALS_IN_PROGRESS,
  ARCHIVE_GOALS_SUCCESS,
  ARCHIVE_GOALS_FAILED,
  REFRESH_GOALS,
  NEW_GOALS_SUCCESS,
  NEW_GOALS_FAILED,
} from "../../../constants/store";

const initialState = {
  data: false,
  message: "",
  status: true,
  goals: [],
  update: {
    loading: false,
    success: false,
    error: false,
  },
  get: {
    loading: false,
    success: false,
    error: false,
  },
  add: {
    loading: false,
    success: false,
    error: false,
  },
  archive: {
    loading: false,
    success: false,
    error: false,
  },
};

const DEFAULT_STATES = { loading: false, success: false, error: false };

function goalsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_GOALS_IN_PROGRESS:
      return {
        ...state,
        status: true,
        get: {
          ...DEFAULT_STATES,
          loading: true,
        },
      };

    case GET_GOALS_SUCCESS:
      return {
        ...state,
        status: false,
        get: {
          ...DEFAULT_STATES,
          success: true,
        },
        goals: action.payload.data,
      };

    case GET_GOALS_FAILED:
      return {
        ...state,
        get: {
          ...DEFAULT_STATES,
          error: true,
        },
        status: false,
      };

    case UPDATE_GOALS_IN_PROGRESS:
      return {
        ...state,
        update: {
          ...DEFAULT_STATES,
          loading: true,
        },
        status: true,
      };

    case UPDATE_GOALS_SUCCESS:
      return {
        ...state,
        update: {
          ...DEFAULT_STATES,
          success: action.payload,
        },
        status: true,
        updated: action.payload == 200 ? true : false,
      };

    case UPDATE_GOALS_FAILED:
      return {
        ...state,
        status: false,
        update: {
          ...DEFAULT_STATES,
          error: true,
        },
        updated: false,
      };

    case ARCHIVE_GOALS_IN_PROGRESS:
      return {
        ...state,
        archive: {
          ...DEFAULT_STATES,
          loading: true,
        },
        status: true,
      };

    case ARCHIVE_GOALS_SUCCESS:
      return {
        ...state,
        status: false,
        archive: {
          ...DEFAULT_STATES,
          success: action.payload,
        },
        updated: action.payload == 200 ? true : false,
      };

    case ARCHIVE_GOALS_FAILED:
      return {
        ...state,
        status: false,
        archive: {
          ...DEFAULT_STATES,
          error: true,
        },
        updated: true,
      };

    case REFRESH_GOALS:
      return {
        ...state,
        updated: false,
      };

    case NEW_GOALS_SUCCESS:
      return {
        ...state,
        add: {
          ...DEFAULT_STATES,
          success: action.payload,
        },
        updated: action.payload.status == 200 ? true : false,
      };

    case NEW_GOALS_FAILED:
      return {
        ...state,
        add: {
          ...DEFAULT_STATES,
          error: true,
        },
        updated: false,
      };

    default:
      return state;
  }
}

export default goalsReducer;
